module.exports = __webpack_public_path__ + "static/media/400007_02.a13b218c.png";